module.exports = __webpack_public_path__ + "643db13ef40eaf499aa4f1e082d194a8.png";